


















































































































import { defineComponent, computed, PropType, watch, ref } from '@vue/composition-api';
import { BrandSafetyType } from '@tt4b/ttam-enums';
import { InventoryFilterOptions } from './hooks';
import LearnMore from '@/components/common/learn-more/index.vue';

const InventoryTiersTrackingName = {
  [BrandSafetyType.UN_SAFE]: 'Full',
  [BrandSafetyType.EXPANDED_INVENTORY]: 'Expanded',
  [BrandSafetyType.STANDARD_INVENTORY]: 'Standard',
  [BrandSafetyType.SELCTED_INVENTORY]: 'Limited',
};

const name = 'ttam-inventroy-filter-dialog';

export default defineComponent({
  name,
  components: {
    LearnMore,
  },
  props: {
    brandSafety: {
      type: Number as PropType<BrandSafetyType>,
      default: undefined,
    },
    options: {
      type: Array as PropType<InventoryFilterOptions[]>,
      default: () => [],
    },
    visible: {
      type: Boolean,
      default: false,
    },
    replaceFullToExpanded: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const selectedVal = ref(0);

    const isFilterEditDialogVisible = computed({
      get() {
        return props.visible;
      },
      set(val) {
        emit('update:visible', val);
      },
    });

    watch(isFilterEditDialogVisible, val => {
      if (val) {
        selectedVal.value = props.brandSafety;
      }
    });

    const onClickOpt = option => {
      if (!option.isDisabled) {
        selectedVal.value = option.value;
      }
    };

    return {
      name,
      selectedVal,
      isFilterEditDialogVisible,
      InventoryTiersTrackingName,
      onClickOpt,
    };
  },
});
